// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wtEWp70_9QKzn9M0 {
  color: #20336c;
  background-color: transparent;
  border: none;
}

.qxDY4BRGnH8Vm2s7, .UcKJhfbNDA9rQbFi {
    width: 100px;
  height: 46px;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.qxDY4BRGnH8Vm2s7 {
  background-color: #56be4d;
  border-color: #56be4d;
}

.qxDY4BRGnH8Vm2s7:hover {
  background-color: #4eac46;
  border-color: #4eac46;
}

.qxDY4BRGnH8Vm2s7:active {
  background-color: #44963d;
  border-color: #44963d;
}

.qxDY4BRGnH8Vm2s7:focus {
  box-shadow: none;
}

.qxDY4BRGnH8Vm2s7:focus-visible {
  box-shadow: 0 0 0 0.2rem #4eac46;
}

.qxDY4BRGnH8Vm2s7:disabled,
.qxDY4BRGnH8Vm2s7[disabled] {
  cursor: not-allowed;
  background-color: #cfeed9;
  border-color: #cfeed9;
  color: #8cbf9a;
}

.UcKJhfbNDA9rQbFi {
  background-color: #4d87be;
  border-color: #4d87be;
  cursor: pointer;
}

.THFDABOtB8VfdlFg {
  background-color: #4d87be;
  border-color: #4d87be;
  cursor: pointer;
  height: 46px;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 600;
  padding-inline: 16px;
}

.UcKJhfbNDA9rQbFi:hover {
  border-color: #20336c;
  background-color: #20336c;
}

.mV5mfVWycaiLOOHF {
  width: 220px;
  padding-inline: 22px;
  border-radius: 16px;
  height: 46px;
  font-size: 20px;
  border: none;
  outline: none;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.mV5mfVWycaiLOOHF::placeholder {
  color: #a4a4a4;
  font-size: 16px;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/OrderPage/components/TelegramNotificationField/TelegramNotificationField.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;IACI,YAAY;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".telegramButton {\r\n  color: #20336c;\r\n  background-color: transparent;\r\n  border: none;\r\n}\r\n\r\n.verify, .resend {\r\n    width: 100px;\r\n  height: 46px;\r\n  border-radius: 16px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.verify {\r\n  background-color: #56be4d;\r\n  border-color: #56be4d;\r\n}\r\n\r\n.verify:hover {\r\n  background-color: #4eac46;\r\n  border-color: #4eac46;\r\n}\r\n\r\n.verify:active {\r\n  background-color: #44963d;\r\n  border-color: #44963d;\r\n}\r\n\r\n.verify:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.verify:focus-visible {\r\n  box-shadow: 0 0 0 0.2rem #4eac46;\r\n}\r\n\r\n.verify:disabled,\r\n.verify[disabled] {\r\n  cursor: not-allowed;\r\n  background-color: #cfeed9;\r\n  border-color: #cfeed9;\r\n  color: #8cbf9a;\r\n}\r\n\r\n.resend {\r\n  background-color: #4d87be;\r\n  border-color: #4d87be;\r\n  cursor: pointer;\r\n}\r\n\r\n.disconnect {\r\n  background-color: #4d87be;\r\n  border-color: #4d87be;\r\n  cursor: pointer;\r\n  height: 46px;\r\n  border-radius: 16px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  padding-inline: 16px;\r\n}\r\n\r\n.resend:hover {\r\n  border-color: #20336c;\r\n  background-color: #20336c;\r\n}\r\n\r\n.input {\r\n  width: 220px;\r\n  padding-inline: 22px;\r\n  border-radius: 16px;\r\n  height: 46px;\r\n  font-size: 20px;\r\n  border: none;\r\n  outline: none;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.input::placeholder {\r\n  color: #a4a4a4;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var telegramButton = `wtEWp70_9QKzn9M0`;
export var verify = `qxDY4BRGnH8Vm2s7`;
export var resend = `UcKJhfbNDA9rQbFi`;
export var disconnect = `THFDABOtB8VfdlFg`;
export var input = `mV5mfVWycaiLOOHF`;
export default ___CSS_LOADER_EXPORT___;
